/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, HostListener, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { HttpModule } from '@angular/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { NegocioDataService } from './services/negocio-data.service';
import Utils from './shared/utils';
import { ToasterConfig, ToasterService } from 'angular2-toaster';

const TIME_LOGOFF = environment.timeOut;

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,
    private router: Router,
    private negocioDataService: NegocioDataService,
    ) {
      this.gravarUsuarioOnline();
      //this.validaPermissaoBotaoOnline();
  }

  get loggedEmployee(): string {
    return this.negocioDataService.getEmployee();
  }

  get permiteTempoIlimitado(): boolean {
    return this.negocioDataService.getPermissaoUnica(5);
  }

  errorType = 'error';

  public usoTela: number = 0;
  private lastActivity: Date;
  private intervalId: any;
  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  @HostListener('document:touchstart', ['$event'])

  onUserActivity(event: MouseEvent | KeyboardEvent | TouchEvent) {
    this.usoTela =  this.usoTela + 1;

    if (this.usoTela === 1) {
      this.lastActivity = new Date(); // Atualizar a última atividade apenas quando usoTela for alterado pela primeira vez
    }
  }

  updateLastActivity() {
    this.lastActivity = new Date(); // Atualizar a última atividade com a data e hora atual
  }

  checkInactivity() {
    const currentTime = new Date();
    let inactiveTime = (currentTime.getTime() - this.lastActivity.getTime()) / 60000; // Diferença de tempo em minutos

    const limiteInatividade = TIME_LOGOFF; // Limite de inatividade em minutos

    if (this.loggedEmployee.toUpperCase() != "FB2BA38C-B0A3-4DD0-865A-B860512444FF"){
      if (inactiveTime > limiteInatividade) {
        if (this.usoTela == 0) {
          if (!this.negocioDataService.getPermissaoUnica(5)){
              this.router.navigate(['/auth/logout']);
              clearInterval(this.intervalId);
          }
        } else {
          this.usoTela = 0;
          this.lastActivity = new Date();
        }
      }
    }
  }

  ngOnDestroy() {
    // Limpar o intervalo quando o serviço for destruído
    clearInterval(this.intervalId);
  }

  async ngOnInit() {
    this.analytics.trackPageViews();

      this.intervalId = setInterval(() => {
        this.checkInactivity();
      }, 100);// 60000); // 60000ms = 1 minuto
  }

  gravarUsuarioOnline(){
    const result = this.negocioDataService.createUserLogOnline();
  }
}
